module.exports = __webpack_public_path__ + "static/img/empty.60f6358.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/search/empty.png
// module id = Cpgc
// module chunks = 6 9